/** DB `prompt_templates.type` values — keep in sync with backend admin.service addPromptTemplate. */

export const PROMPT_TEMPLATE_TYPES = {
  INFLUENCER_NEW: "new",
  INFLUENCER_VARIATION: "variation",
  VIDEO_SEEDANCE: "video-seedance",
  VIDEO_KLING: "video-kling",
  VIDEO_GENERIC: "video-generic",
};

/** @type {string[]} */
export const ALL_PROMPT_TEMPLATE_TYPES = Object.values(PROMPT_TEMPLATE_TYPES);

export const INFLUENCER_PROMPT_TYPES = [
  PROMPT_TEMPLATE_TYPES.INFLUENCER_NEW,
  PROMPT_TEMPLATE_TYPES.INFLUENCER_VARIATION,
];

export const VIDEO_PROMPT_TYPES = [
  PROMPT_TEMPLATE_TYPES.VIDEO_SEEDANCE,
  PROMPT_TEMPLATE_TYPES.VIDEO_KLING,
  PROMPT_TEMPLATE_TYPES.VIDEO_GENERIC,
];
